<template>
  <div
    v-if="tierTitle"
    class="earnrate-item cell small-12 medium-12 large-4 mlarge-4 small-margin-bottom-s medium-margin-bottom-s large-margin-bottom-z header"
    :class="earnRate.tierClass"
  >
    <div class="padding-s">
      <div class="tier-earnrate-header margin-bottom-s">
        <div class="h5 margin-bottom-xxs">
          {{ tierTitle }}
        </div>
        <div class="small">
          {{ earnRate.tierDesc }}
        </div>
      </div>
      <div class="margin-bottom-s grid-x">
        <div class="content-wrapper small-9 medium-9 large-12 mlarge-9">
          <div class="heavy margin-bottom-xxs">
            {{ earnRate.sectionOne.textOne }}
          </div>
          <div
            class="small"
            v-html="earnRate.sectionOne.textTwo"
          ></div>
        </div>
      </div>
      <div class="margin-bottom-s earnrate-border"></div>
      <div class="margin-bottom-s grid-x earnrate-txt-img-wrapper">
        <div class="content-wrapper small-9 medium-9 large-12 mlarge-9 padding-right-xs">
          <div class="heavy margin-bottom-xxs">
            {{ earnRate.sectionTwo.textOne }}
          </div>
          <div class="small">
            {{ earnRate.sectionTwo.textTwo }}
          </div>
        </div>
        <div class="image-wrapper small-3 medium-3 large-12 mlarge-3 medium-margin-bottom-z large-margin-bottom-xs mlarge-margin-bottom-z">
          <img
            :src="getImagePath(`${earnRate.sectionTwo.image}`)"
            alt=""
          />
        </div>
      </div>
      <div class="margin-bottom-s earnrate-border">
        <label class="earnrate-border-label small padding-xxs">{{ OR }}</label>
      </div>
      <div class="grid-x earnrate-txt-img-wrapper">
        <div class="content-wrapper small-9 medium-9 large-12 mlarge-9 padding-right-xs">
          <div class="heavy margin-bottom-xxs">
            {{ earnRate.sectionThree.textOne }}
          </div>
          <div class="small margin-bottom-xxs">
            {{ earnRate.sectionThree.textTwo }}
          </div>
          <div class="small">
            <a
              href="#"
              @click.prevent="scrollToPoint('6')"
              >{{ POINT_EXCLUSIONS }}</a
            >
          </div>
        </div>
        <div class="image-wrapper small-3 medium-3 large-12 mlarge-3 medium-margin-bottom-z large-margin-bottom-xs mlarge-margin-bottom-z">
          <img
            :src="getImagePath(`${earnRate.sectionThree.image}`)"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { toRefs } from 'vue';
import { EARN_RATE, TIER_NAME } from 'config';
import loyallistCreditCardImgOne from '../../assets/images/loyallist/credit-card-2cards.svg';
import loyallistCreditCardImgTwo from '../../assets/images/loyallist/credit-card-1card.svg';
import tolCreditCardImgOne from '../../assets/images/tol/credit-card-2cards.svg';
import tolCreditCardImgTwo from '../../assets/images/tol/credit-card-1card.svg';
import unlCreditCardImgOne from '../../assets/images/unl/credit-card-2cards.svg';
import unlCreditCardImgTwo from '../../assets/images/unl/credit-card-1card.svg';
import scrollToPoint from '../../utils/scrollToPointUtil';

const { POINT_EXCLUSIONS, OR } = EARN_RATE || {};

const imageMap = {
  loyallistCreditCardImgOne,
  loyallistCreditCardImgTwo,
  tolCreditCardImgOne,
  tolCreditCardImgTwo,
  unlCreditCardImgOne,
  unlCreditCardImgTwo,
};

const props = defineProps({
  earnRate: {
    type: Object,
    default() {
      return {};
    },
  },
});
const { earnRate } = toRefs(props);
const tierTitle = TIER_NAME[earnRate.value.tierTitle];
const getImagePath = (image) => imageMap[image];

defineExpose({
  getImagePath,
  tierTitle,
});
</script>


<style lang="scss" scoped>
.tier-earnrate-header {
  div.small {
    color: $gray-1-color;
  }
  @include breakpoint(large only) {
    height: rem-calc(75);
  }
}
.earnrate-item {
  border: rem-calc(1) solid $gray-3-color;
  background: $white;
}
.loyalty-color {
  border-top: rem-calc(16) solid $loyalty-1-color;
}
.tol-color {
  border-top: rem-calc(16) solid $loyalty-2-color;
}
.untol-color {
  border-top: rem-calc(16) solid $loyalty-3-color;
}
.earnrate-border {
  border-bottom: rem-calc(1) dotted $gray-3-color;
  text-align: center;
}
.earnrate-border-label {
  background-color: $white;
  position: absolute;
  transform: translateY(-50%) translateX(-50%);
}
.content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.image-wrapper {
  display: flex;
  justify-content: right;
  align-items: flex-start;
  flex-shrink: 0;
  @include breakpoint(large only) {
    justify-content: left;
  }
}
.earnrate-txt-img-wrapper {
  justify-content: space-between;
  flex-direction: row;
  @include breakpoint(large only) {
    flex-direction: column-reverse;
  }
}
.earnrate-item:last-of-type {
  @include breakpoint(large down) {
    margin-bottom: 0 !important;
  }
}
</style>